import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import ServerPageInterface from 'server/types/ServerPageInterface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'

const addQuestionsToCalendar = (
  entity: BookingCalendarInterface,
): BookingCalendarInterface => {
  if (!entity.questions) {
    entity.questions = []
  }

  return entity
}

export default (page: ServerPageInterface) =>
  migrateCommand({
    page,
    structureType: EntityTypeEnum.BookingCalendar,
    migrateFunction: addQuestionsToCalendar,
  })
